export const PHOTOALBUMSGET_REQUEST = 'PHOTOALBUMSGET_REQUEST';
export const PHOTOALBUMSGET_SUCCESS = 'PHOTOALBUMSGET_SUCCESS';
export const PHOTOALBUMSGET_FAIL = 'PHOTOALBUMSGET_FAIL';

export const PHOTOALBUM_SELECT = 'PHOTOALBUM_SELECT';
export const PHOTOALBUMS_SELECTALL = 'PHOTOALBUMS_SELECTALL';
export const PHOTOALBUMS_DROPSELECTION = 'PHOTOALBUMS_DROPSELECTION';

export const PHOTOALBUM_SELECTIMG = 'PHOTOALBUM_SELECTIMG';
export const PHOTOALBUM_SELECTALLIMGS = 'PHOTOALBUM_SELECTALLIMGS';
export const PHOTOALBUM_DROPIMGSELECT = 'PHOTOALBUM_DROPIMGSELECT';



export const PHOTOALBUM_VIEW = 'PHOTOALBUM_VIEW';
export const PHOTOALBUM_CLOSE = 'PHOTOALBUM_CLOSE';


export const PHOTOALBUM_DELSTART = 'PHOTOALBUM_DELSTART';
export const PHOTOALBUM_DELSTOP = 'PHOTOALBUM_DELSTOP';
export const PHOTOALBUM_DELPROGRESS = 'PHOTOALBUM_DELPROGRESS';
export const PHOTOALBUM_DELFAIL = 'PHOTOALBUM_DELFAIL';
export const PHOTOALBUM_DELSUCCESS = 'PHOTOALBUM_DELSUCCESS';



// WEBPACK FOOTER //
// ./src/constants/Photos.js